export const BOOKING_URL = 'https://cal.com/klayder/intro'
export const CONTACT_EMAIL = 'carmelo@klayder.com'
